import { useEffect, useState } from "react";
import { api } from "@cliqsuite/db/powersync";
import type { ModulePreset } from "@cliqsuite/db";

/** Business types (platform.module_presets), sorted. Plain REST: signup runs before login, so nothing syncs yet. */
export function useModulePresets(): { presets: ModulePreset[]; isReady: boolean } {
  const [presets, setPresets] = useState<ModulePreset[] | null>(null);
  useEffect(() => {
    api<{ rows: ModulePreset[] }>("/auth/module-presets")
      .then((b) => setPresets(b.rows))
      .catch(() => setPresets([]));
  }, []);
  return { presets: presets ?? [], isReady: presets !== null };
}
